(function(){
  /*
    Règles Naturazoa :
    - Ramassage lundi au vendredi matin
    - Commande jusqu'à minuit (23:59:59) du dim au jeu inclus => expédition demain
    - Vendredi + samedi => pas d'expédition le lendemain, on cache le timer
  */
  function pad(n){ return n < 10 ? '0' + n : n; }

  function getInfo() {
    var now = new Date();
    var day = now.getDay(); // 0=dim 1=lun 2=mar 3=mer 4=jeu 5=ven 6=sam

    /* Vendredi (5) et Samedi (6) : pas d'expédition le lendemain */
    if (day === 5 || day === 6) return null;

    /* Dimanche à jeudi (0-4) : on peut commander jusqu'à minuit */
    var target = new Date(now);
    target.setHours(23, 59, 59, 999); /* minuit moins une seconde */

    var diff = target - now;
    if (diff <= 0) return null; /* ne devrait pas arriver mais sécurité */

    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    return { h: h, m: m };
  }

  function render(el) {
    var info = getInfo();
    if (!info) {
      el.style.display = 'none';
      return;
    }
    el.style.display = '';
    el.innerHTML =
      '<span class="nz-urgency__dot"></span>' +
      '<span class="nz-urgency__text">Commandez dans les\u00a0</span>' +
      '<span class="nz-urgency__timer">' + pad(info.h) + 'h\u00a0' + pad(info.m) + 'min</span>' +
      '<span class="nz-urgency__text">\u00a0pour une exp\u00e9dition</span>' +
      '<span class="nz-urgency__suffix">\u00a0d\u00e8s demain</span>';
  }

  document.addEventListener('DOMContentLoaded', function() {
    var els = document.querySelectorAll('.nz-urgency');
    els.forEach(function(el) {
      render(el);
      setInterval(function(){ render(el); }, 30000);
    });
  });
})();
